function updateGiftWrap(checkbox) {
  document.dispatchEvent(new CustomEvent("baseline:cart:lock"));
  const itemKey = checkbox.dataset.key,
        itemQty = checkbox.dataset.qty,
        isChecked = checkbox.checked;

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: itemKey,
      quantity: itemQty,
      properties: {
        "_gift_wrap": isChecked ? "Yes" : null,
      },
    }),
  })
    .then((res) => res.json())
    .then((cart) => {
      document.dispatchEvent(new CustomEvent("theme:update:cart"));
    })
    .catch((err) => {
      console.error("Gift wrap update error:", err);
    });
}